import { Component, Input, OnInit } from '@angular/core';
import { Color } from '@ionic/core';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
})
export class ItemComponent implements OnInit {

  @Input() color:Color = 'white';
  @Input() button:boolean = true;
  @Input() icon:string;
  @Input() lines:string = "none";

  constructor() { }

  ngOnInit() {}

}
